import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table ,Form} from "react-bootstrap";
import trasportApi from "../../api/trasportApi";
import { ShimmerTable } from "react-shimmer-effects";
import Main from "../layout/Main";
import DriverEdit from "./DriverEdit";
import Confirm from '../Confirm';
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import InfoPill from "../InfoPill";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";

// React Icons Starts Here
import { FiEdit } from "react-icons/fi";
import { FaTrashAlt } from "react-icons/fa";
import { BsChevronRight } from "react-icons/bs";
//React Icons Ends here.


const SubjectList = () => {
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [driverRec, setBranch] = React.useState({});
  const [modalShowEditBranch, setModalShowEditBranch] = React.useState(false);
  const [financialYearOption, setOptionFinancialYear] = useState([]); // Initialize as an array
  const [tempBody, setTempBody] = useState([]);

  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllBranches = () => {
    async function init() {
      const branch = await trasportApi.fetchAllDrivers();
      if (branch) {
        setBody(branch);
        setTempBody(branch);
      } else {
        setBody([]);
      }
    }
    init();
  }

  useEffect(() => {
    const fetchData = async () => {
      const fnYear = await trasportApi.fetchAllFinancialYears();
      if (fnYear && fnYear.length) {
        let ar = [];
        fnYear.forEach((item) => {
          ar.push({ value: item.id, label: item.name });
        });
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }
    };

    fetchData();
  }, []);

  // Create table headers consisting of 4 columns.
  const header = [
    { title: "Driver Name", prop: "driver_name", isFilterable: true },
    { title: "Email", prop: "email", isFilterable: true },
    { title: "Phone", prop: "phone", isFilterable: true },
    { title: "Address", prop: "address", isFilterable: true },
    { title: "Financial Year", prop: "financial_year_name", isFilterable: true },
    
  ];
  
    header.push({
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <div>
          <Button className='btn-sm mx-2' onClick={() => editFinancialYearList(row)}><FiEdit /></Button>
          <Button variant="danger" className='btn-sm mx-2' onClick={() => handleDelete(row)}><FaTrashAlt/></Button>
        </div>
      ),
    });


  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createBranch = () => {
    setBranch({});
    setModalShowEditBranch(true);
  };

  const submitFinancialYearList = () => {
    // setModalShowCreateDoctorDuty(false);
    // setModalShowEditBranch(false);
    // fetchAllDuties();
    // setDoctorDuty({});
  }

  const editFinancialYearList = (row) => {
    setModalShowEditBranch(true);
    setBranch(row);
  }

  const handleDelete = (row) => {
    console.log(row);
    setModalShow(true);
    setBranch(row);
  }
  const isdelete = async () => {    
    const result = await trasportApi.deleteDrivers(driverRec.id);
    if (result.success) {
      setBranch('');
      setModalShow(false);
      fetchAllBranches();
    }
  }
  const onFilterTypeYear = async (event) => {
    var arr = [];
    tempBody.forEach((item) => {
      if (item.financial_year_name === event.target.value) {
        arr.push(item);
      }
    });
    setBody(arr.length > 0 ? arr : tempBody);
  };
  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.DriverList}</title>
        </Helmet>
      </>

      {modalShowEditBranch &&
        <DriverEdit
          show={modalShowEditBranch}
          onHide={() => setModalShowEditBranch(false)}
          submitFinancialYearList={submitFinancialYearList}
          driverRec={driverRec ? driverRec : {}}
        />
      }

      {modalShow &&
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          isdelete={isdelete}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="Driver"
        />}

      <Row className="g-0">
        <Col lg={2} className="mx-2">
          <Link to="/home" style={{ "text-decoration": "none" }}>
            Home
          </Link>
          {/* <i className="fa-solid fa-chevron-right"></i>  */}
          <BsChevronRight/>
          Driver List
        </Col>
        <Col lg={12} className="p-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-start align-items-center"
                >
                  <PaginationOptions labels={labels} />
                  <InfoPill left="Total" right={body?.length} />
                  <Form.Group className="mx-3 mt-4" controlId="formBasicCourses">
                    <Form.Select aria-label="Enter Financial Year" name="financial_year_name" onChange={onFilterTypeYear}>
                      <option value="">--Select Financial Year--</option>
                      <option value="">All</option>
                      {financialYearOption.map((option) => (
                        <option key={option.value} value={option.label}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-md"
                    variant="primary"
                    onClick={() => createBranch(true)}
                  >
                    New Driver
                  </Button>
                </Col>
              </Row>

              <Table striped className="data-table">
                <TableHeader />

                <TableBody />
              </Table>

              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </Main>
  );
};
export default SubjectList;
